import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceTypeEnum } from '../../../enum/type/device-type.enum';
import { StorageConstants } from '../../../constant/storage.constant';
import { User } from '../../../models/entity/user';
import { UserLoginRequest } from '../../../models/rest/user/userLoginRequest';
import { AuthService } from '../../../services/auth.service';
import { AlertifyService } from '../../../services/core/alertify.service';
import { UserService } from '../../../services/user/user.service';
import { SessionStorageService } from '../../../services/session-storage.service';
import { ArrayUtils } from '../../../utils/array.utils';
import { UserLoginResponse } from '../../../models/rest/user/userLoginResponse';
import { firstValueFrom } from 'rxjs';
import { StringUtils } from 'app/utils/string.utils';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-lock-screen',
  templateUrl: './lock-screen.component.html',
  styleUrls: ['./lock-screen.component.css']
})
export class LockScreenComponent implements OnInit {
  public capslockOn: boolean = false;

  @HostListener('window:click', ['$event']) onClick(event) {
    if (event.getModifierState && event.getModifierState('CapsLock')) {
      this.capslockOn = true;
    } else {
      this.capslockOn = false;
    }
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event) {
    if (event.getModifierState && event.getModifierState('CapsLock')) {
      this.capslockOn = true;
    } else {
      this.capslockOn = false;
    }
  }

  @HostListener('window:keyup', ['$event'])
  onKeyUp(event) {
    if (event.getModifierState && event.getModifierState('CapsLock')) {
      this.capslockOn = true;
    } else {
      this.capslockOn = false;
    }
  }
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  users: User[];
  selectedUser: User | null = null;
  password: string;
  loading: boolean = false;
  errorCount: number = 0;
  constructor(
    private sessionStorageService: SessionStorageService,
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    private alertifyService: AlertifyService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.sessionStorageService.setString(StorageConstants.IS_IDDLE, "1");
    this.getData();
  }

  getData() {
    this.userService.getUsers().subscribe(
      (res) => {
        this.users = res;
        this.users = this.users.filter(x => x.storeId == this.authService.getStoreId());
        this.users = ArrayUtils.sortBy(this.users, "screenName");
        this.selectedUser = ArrayUtils.firstOrDefault(this.users, x => x.id == this.authService.getCurrentUserId());
      },
      (err) => {
        this.alertifyService.error(err);

      }
    );
  }

  close() {
    this.passEntry.emit();
  }

  checkPin() {
    this.passEntry.emit(true);
  }

  loginUser() {
    if (this.selectedUser == null) {
      this.alertifyService.error(this.translate.instant("message.warning.please-select-user"));
      return;
    }

    if (StringUtils.isEmpty(this.password)) {
      this.alertifyService.error(this.translate.instant("authentication.password-can-not-be-empty"));
      return;
    }

    if (this.errorCount > 2) {
      this.passEntry.emit();
    }

    if (this.selectedUser!.id == this.authService.getCurrentUserId()) {

      this.checkUserPassword();
    }
    else {
      this.loginNewUser();
    }
  }

  checkUserPassword() {
    this.loading = true;
    this.userService.checkPassword(this.selectedUser!.userName!, this.password).subscribe(
      (data) => {
        this.loading = false;
        this.passEntry.emit(true);
      },
      (err) => {
        this.loading = false;
        this.errorCount++;
        this.alertifyService.error(err);
      }
    );
  }

  loginNewUser() {
    this.loading = true;
    let userLoginRequest = new UserLoginRequest();
    userLoginRequest.userName = this.selectedUser!.userName!;
    userLoginRequest.password = this.password;
    userLoginRequest.deviceCode = this.authService.getCurrenDeviceCode();
    userLoginRequest.deviceType = DeviceTypeEnum.WEB;

    this.userService.login(userLoginRequest).subscribe(
      (data) => {
        this.loading = false;
        this.authService.saveToken(data.token);
        this.authService.saveRefreshToken(data.refreshToken);
        // this.authService.startRefreshTokenTimer();
        this.getSessionInfo(data);

      },
      (err) => {

        this.loading = false;

        if (err != "OK") this.alertifyService.error(err);
        else
          this.alertifyService.error(
            "İnternet erişimi yok veya sistemsel bir problem mevcut"
          );

        this.passEntry.emit();
      }
    );
  }

  async getSessionInfo(userLoginResponse: UserLoginResponse | null = null) {
    if (!userLoginResponse) {
      userLoginResponse = await firstValueFrom(this.userService.getUserSessionInfo());
    }
    await this.authService.saveAfterLogin(userLoginResponse);
    window.location.reload();
  }

}
